import { get, post, put, remove } from "../../utils/httpClient";

const taskTypeService = () => {
  const prefixApi = "duedates/tasktypes";

  const getTaskTypeByBoardId = async (boardId) => {
    return await get(`/${prefixApi}/board`, { boardId: boardId });
  };

  const getTaskType = async (id) => {
    return await get(`/${prefixApi}/${id}`);
  };

  const createTaskType = async (json) => {
    return await post(`/${prefixApi}`, json);
  };

  const createTaxReturnTaskType = async (boardId) => {
    return await post(`/${prefixApi}/taxreturn`, null, { params: { boardId } });
  };

  const updateTaskType = async (json) => {
    return await put(`/${prefixApi}`, json);
  };

  const deleteTaskType = async (id) => {
    return await remove(`/${prefixApi}/${id}`);
  };

  return {
    getTaskTypeByBoardId,
    getTaskType,
    createTaskType,
    createTaxReturnTaskType,
    updateTaskType,
    deleteTaskType,
  };
};

export default taskTypeService;
